// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .table-selection {
  position: absolute;
  top: 35px;
  bottom: 0px;
  overflow: auto;
  width: calc(100% - 10px);
  padding-top: 5px;
}
:host .table-selection .table-type {
  width: 120px;
}
:host .table-selection .data-range {
  width: 100px;
}
:host .table-selection .data-realtime {
  width: 100px;
}
:host .section-item {
  width: 100%;
}
:host .section-item-newline {
  margin-top: 5px;
}
:host .section-newline {
  height: 8px;
  display: block;
}
:host .section-item-block mat-select, :host input, :host span {
  width: calc(100% - 15px);
}
:host .section-inline-name input {
  width: 140px;
}
:host .section-inline-number input {
  max-width: 100px;
}
:host .section-inline-type {
  width: 160px;
}
:host .section-inline-toggle {
  display: inline-block;
  width: 60px;
  text-align: center;
}
:host .section-inline-toggle span {
  width: inherit;
}
:host .section-inline-toggle-ext span {
  width: 85px;
  text-align: left;
}
:host .section-inline-toggle-ext mat-slide-toggle {
  padding-left: 20px;
}
:host .section-inline-color {
  display: inline-block;
  width: 60px;
}
:host .section-inline-color input {
  width: 60px !important;
  text-align: center;
}
:host .section-inline-color span {
  width: 65px;
}
:host .section-inline-margin {
  display: inline-block;
  width: 12px;
}
:host .section-inline-margin2 {
  display: inline-block;
  width: 16px;
}
:host .toolbox {
  z-index: 1000;
  position: absolute;
  right: 10px;
  top: -8px;
  line-height: 44px;
}
:host .toolbox button {
  /* margin-right: 8px; */
  margin-left: 10px;
}
:host ::ng-deep .mat-tab-label {
  height: 34px !important;
  min-width: 110px !important;
  width: 110px !important;
}
:host .tab-columns-rows {
  width: calc(100% - 15px);
}
:host .cell-item {
  padding-top: 5px;
  padding-bottom: 5px;
  border-bottom: 1px solid var(--toolboxBorder);
}
:host .events-section {
  display: contents;
}
:host .events-section .event-item {
  margin-top: 5px;
}
:host .events-section .event-type {
  width: 120px;
}
:host .events-section .event-action {
  width: 120px;
}
:host .events-section .event-remove {
  float: right;
}
:host .events-section .event-action-ext {
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
:host .events-section .event-script {
  padding-left: 10px;
}
:host .events-section .event-script .script-selection {
  width: calc(100% - 15px);
}
:host .events-section .event-script .event-script-param {
  width: 120px;
}
:host .events-section .event-script .event-script-value {
  width: calc(100% - 120px);
}
:host .events-section .event-script .event-script-tag {
  width: calc(100% - 125px);
}
:host .events-toolbox {
  display: block;
  width: 100%;
}
:host .events-toolbox button {
  margin-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/gauges/controls/html-table/table-property/table-property.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/gauges/controls/html-table/table-property/table-property.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,wBAAA;EACA,gBAAA;ACAR;ADCQ;EACI,YAAA;ACCZ;ADEQ;EACI,YAAA;ACAZ;ADGQ;EACI,YAAA;ACDZ;ADKI;EACI,WAAA;ACHR;ADMI;EACI,eAAA;ACJR;ADOI;EACI,WAAA;EACA,cAAA;ACLR;ADQI;EACI,wBAAA;ACNR;ADSI;EACI,YAAA;ACPR;ADUI;EACI,gBAAA;ACRR;ADWI;EACI,YAAA;ACTR;ADYI;EACI,qBAAA;EACA,WAAA;EACA,kBAAA;ACVR;ADaI;EACI,cAAA;ACXR;ADcI;EACI,WAAA;EACA,gBAAA;ACZR;ADeI;EACI,kBAAA;ACbR;ADgBI;EACI,qBAAA;EACA,WAAA;ACdR;ADiBI;EACI,sBAAA;EACA,kBAAA;ACfR;ADkBI;EACI,WAAA;AChBR;ADmBI;EACI,qBAAA;EACA,WAAA;ACjBR;ADoBI;EACI,qBAAA;EACA,WAAA;AClBR;ADqBI;EACI,aAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,iBAAA;ACnBR;ADsBI;EACI,uBAAA;EACA,iBAAA;ACpBR;ADuBI;EACI,uBAAA;EACA,2BAAA;EACA,uBAAA;ACrBR;ADwBI;EACI,wBAAA;ACtBR;ADyBI;EACI,gBAAA;EACA,mBAAA;EACA,6CAAA;ACvBR;AD0BI;EACI,iBAAA;ACxBR;AD0BQ;EACI,eAAA;ACxBZ;AD0BQ;EACI,YAAA;ACxBZ;AD0BQ;EACI,YAAA;ACxBZ;AD0BQ;EACI,YAAA;ACxBZ;AD0BQ;EACI,oBAAA;EACA,2CAAA;ACxBZ;AD0BQ;EACI,kBAAA;ACxBZ;ADyBY;EACI,wBAAA;ACvBhB;ADyBY;EACI,YAAA;ACvBhB;ADyBY;EACI,yBAAA;ACvBhB;ADyBY;EACI,yBAAA;ACvBhB;AD2BI;EACI,cAAA;EACA,WAAA;ACzBR;AD2BQ;EACI,iBAAA;ACzBZ","sourcesContent":[":host {\n    .table-selection {\n        position: absolute;\n        top: 35px;\n        bottom: 0px;\n        overflow: auto;\n        width:calc(100% - 10px);\n        padding-top: 5px;\n        .table-type {\n            width: 120px;\n        }\n\n        .data-range {\n            width: 100px;\n        }\n\n        .data-realtime {\n            width: 100px;\n        }\n    }\n\n    .section-item {\n        width: 100%;\n    }\n\n    .section-item-newline {\n        margin-top: 5px;\n    }\n\n    .section-newline {\n        height: 8px;\n        display: block;\n    }\n\n    .section-item-block mat-select, input, span {\n        width:calc(100% - 15px);\n    }\n\n    .section-inline-name input {\n        width: 140px;\n    }\n\n    .section-inline-number input {\n        max-width: 100px;\n    }\n\n    .section-inline-type {\n        width: 160px;\n    }\n\n    .section-inline-toggle {\n        display: inline-block;\n        width: 60px;\n        text-align: center;\n    }\n\n    .section-inline-toggle span {\n        width: inherit;\n    }\n\n    .section-inline-toggle-ext span {\n        width: 85px;\n        text-align: left;\n    }\n\n    .section-inline-toggle-ext mat-slide-toggle {\n        padding-left: 20px;\n    }\n\n    .section-inline-color {\n        display: inline-block;\n        width: 60px;\n    }\n\n    .section-inline-color input {\n        width: 60px !important;\n        text-align: center;\n    }\n\n    .section-inline-color span {\n        width: 65px;\n    }\n\n    .section-inline-margin {\n        display: inline-block;\n        width: 12px;\n    }\n\n    .section-inline-margin2 {\n        display: inline-block;\n        width: 16px;\n    }\n\n    .toolbox {\n        z-index: 1000;\n        position: absolute;\n        right: 10px;\n        top: -8px;\n        line-height: 44px;\n    }\n\n    .toolbox button {\n        /* margin-right: 8px; */\n        margin-left: 10px;\n    }\n\n    ::ng-deep .mat-tab-label {\n        height: 34px !important;\n        min-width: 110px !important;\n        width: 110px !important;\n    }\n\n    .tab-columns-rows {\n        width:calc(100% - 15px);\n    }\n\n    .cell-item {\n        padding-top: 5px;\n        padding-bottom: 5px;\n        border-bottom: 1px solid var(--toolboxBorder);\n    }\n\n    .events-section {\n        display: contents;\n\n        .event-item {\n            margin-top: 5px;\n        }\n        .event-type {\n            width: 120px;\n        }\n        .event-action {\n            width: 120px;\n        }\n        .event-remove {\n            float: right;\n        }\n        .event-action-ext {\n            padding-bottom: 10px;\n            border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n        }\n        .event-script {\n            padding-left: 10px;\n            .script-selection {\n                width: calc(100% - 15px);\n            }\n            .event-script-param {\n                width: 120px;\n            }\n            .event-script-value {\n                width: calc(100% - 120px);\n            }\n            .event-script-tag {\n                width: calc(100% - 125px);\n            }\n        }\n    }\n    .events-toolbox {\n        display: block;\n        width: 100%;\n\n        button {\n            margin-left: 10px;\n        }\n    }\n}",":host .table-selection {\n  position: absolute;\n  top: 35px;\n  bottom: 0px;\n  overflow: auto;\n  width: calc(100% - 10px);\n  padding-top: 5px;\n}\n:host .table-selection .table-type {\n  width: 120px;\n}\n:host .table-selection .data-range {\n  width: 100px;\n}\n:host .table-selection .data-realtime {\n  width: 100px;\n}\n:host .section-item {\n  width: 100%;\n}\n:host .section-item-newline {\n  margin-top: 5px;\n}\n:host .section-newline {\n  height: 8px;\n  display: block;\n}\n:host .section-item-block mat-select, :host input, :host span {\n  width: calc(100% - 15px);\n}\n:host .section-inline-name input {\n  width: 140px;\n}\n:host .section-inline-number input {\n  max-width: 100px;\n}\n:host .section-inline-type {\n  width: 160px;\n}\n:host .section-inline-toggle {\n  display: inline-block;\n  width: 60px;\n  text-align: center;\n}\n:host .section-inline-toggle span {\n  width: inherit;\n}\n:host .section-inline-toggle-ext span {\n  width: 85px;\n  text-align: left;\n}\n:host .section-inline-toggle-ext mat-slide-toggle {\n  padding-left: 20px;\n}\n:host .section-inline-color {\n  display: inline-block;\n  width: 60px;\n}\n:host .section-inline-color input {\n  width: 60px !important;\n  text-align: center;\n}\n:host .section-inline-color span {\n  width: 65px;\n}\n:host .section-inline-margin {\n  display: inline-block;\n  width: 12px;\n}\n:host .section-inline-margin2 {\n  display: inline-block;\n  width: 16px;\n}\n:host .toolbox {\n  z-index: 1000;\n  position: absolute;\n  right: 10px;\n  top: -8px;\n  line-height: 44px;\n}\n:host .toolbox button {\n  /* margin-right: 8px; */\n  margin-left: 10px;\n}\n:host ::ng-deep .mat-tab-label {\n  height: 34px !important;\n  min-width: 110px !important;\n  width: 110px !important;\n}\n:host .tab-columns-rows {\n  width: calc(100% - 15px);\n}\n:host .cell-item {\n  padding-top: 5px;\n  padding-bottom: 5px;\n  border-bottom: 1px solid var(--toolboxBorder);\n}\n:host .events-section {\n  display: contents;\n}\n:host .events-section .event-item {\n  margin-top: 5px;\n}\n:host .events-section .event-type {\n  width: 120px;\n}\n:host .events-section .event-action {\n  width: 120px;\n}\n:host .events-section .event-remove {\n  float: right;\n}\n:host .events-section .event-action-ext {\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n:host .events-section .event-script {\n  padding-left: 10px;\n}\n:host .events-section .event-script .script-selection {\n  width: calc(100% - 15px);\n}\n:host .events-section .event-script .event-script-param {\n  width: 120px;\n}\n:host .events-section .event-script .event-script-value {\n  width: calc(100% - 120px);\n}\n:host .events-section .event-script .event-script-tag {\n  width: calc(100% - 125px);\n}\n:host .events-toolbox {\n  display: block;\n  width: 100%;\n}\n:host .events-toolbox button {\n  margin-left: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
